module.exports = __webpack_public_path__ + "img/GroupN13.badb2165.png";